import axios from 'axios';

import {
  ADD_WORD,
  GET_ERRORS,
  CLEAR_ERRORS,
  GET_WORDS,
  GET_WORD,
  WORD_LOADING,
  DELETE_WORD,
  RANDOM_WORD
} from './types';

// Add Word
export const addWord= wordData => dispatch => {
  dispatch(clearErrors());
  axios
    .post('/api/glossary/add', wordData)
    .then(res =>
      dispatch({
        type: ADD_WORD,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

// Get Posts
export const getWords = () => dispatch => {
  dispatch(setWordLoading());
  axios
    .get('/api/glossary')
    .then(res =>
      {
        console.log(res);
        dispatch({
          type: GET_WORDS,
          payload: res.data
        })
      }
    )
    .catch(err =>
      dispatch({
        type: GET_WORDS,
        payload: null
      })
    );
};

export const getWordsByTopic = (topic) => dispatch => {
  dispatch(setWordLoading());
  axios
    .get(`/api/glossary/topic/${topic}`)
    .then(res =>
      {
        console.log(res);
        dispatch({
          type: GET_WORDS,
          payload: res.data
        })
      }
    )
    .catch(err =>
      dispatch({
        type: GET_WORDS,
        payload: null
      })
    );
};

// Get Word
export const getWord = id => dispatch => {
  dispatch(setWordLoading());
  axios
    .get(`/api/glossary/${id}`)
    .then(res =>
      dispatch({
        type: GET_WORD,
        payload: res.data
      })
    )
    .catch(err =>
      dispatch({
        type: GET_WORD,
        payload: null
      })
    );
};

export const randomWord = () => dispatch => {
  dispatch(setWordLoading());
  axios
    .get('/api/glossary/random')
    .then(res =>
      {
        console.log(res);
        dispatch({
          type: RANDOM_WORD,
          payload: res.data
        })
      }
    )
    .catch(err =>
      dispatch({
        type: RANDOM_WORD,
        payload: null
      })
    );
};

// Delete Post
export const deleteWord = id => dispatch => {
  axios
    .delete(`/api/glossary/${id}`)
    .then(res =>
      dispatch({
        type: DELETE_WORD,
        payload: id
      })
    )
    .catch(err =>
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data
      })
    );
};

export const saveOrUpdate = (data) => {
  data.token = "cclmagicS1T2";
  if (data._id) {
    return axios.post('/api/glossary/update', data); 
  }
  return axios.post('/api/glossary/add', data);
}

export const deleteGlossary = (id) => {
  return axios.delete(`/api/glossary/${id}`); 
}

// Set loading state
export const setWordLoading = () => {
  return {
    type: WORD_LOADING
  };
};

// Clear errors
export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS
  };
};
